import { tsValidate, tsValidateMustExist, tsValidateNumber, tsValidateRange, tsValidateValue } from '@nu-art/ts-common';
import { EpidemiologyRate_Percentage, EpidemiologyRate_Ratio, EpidemiologyTypes } from './types.js';
import { Validator_Population } from '../population/index.js';
const Validator_EpidemiologyData_Percentage = {
    rate: tsValidateValue([EpidemiologyRate_Percentage]),
    rateValue: tsValidateRange(),
};
const Validator_EpidemiologyData_Ratio = {
    rate: tsValidateValue([EpidemiologyRate_Ratio]),
    rateValue: {
        numerator: tsValidateRange(),
        denominator: tsValidateNumber(),
    },
};
const Validator_EpidemiologyData = (data) => {
    const error = tsValidate(data, tsValidateMustExist);
    if (error)
        return error;
    if (data?.rate === EpidemiologyRate_Percentage)
        return tsValidate(data, Validator_EpidemiologyData_Percentage);
    if (data?.rate === EpidemiologyRate_Ratio)
        return tsValidate(data, Validator_EpidemiologyData_Ratio);
    // @ts-ignore
    return `Missing validator for epidemiology data with rate ${data.rate}`;
};
export const Validator_Epidemiology = {
    type: tsValidateValue([...EpidemiologyTypes]),
    population: Validator_Population,
    data: Validator_EpidemiologyData,
};
//# sourceMappingURL=validator.js.map